import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-系统管理_消息管理",
  "use": "icon-系统管理_消息管理-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-系统管理_消息管理\">\n<path d=\"M14.7,13.1\" />\n<path d=\"M7.6,5.8\" />\n<circle cx=\"8\" cy=\"6.2\" r=\"0.6\" />\n<polygon points=\"8,8.9 0.8,5.4 1.1,4.8 8,8.1 15,4.8 15.4,5.4 \" />\n<g>\n\t<path d=\"M15.3,1.8H0.7C0.4,1.8,0.2,2,0.2,2.3v11.4c0,0.3,0.2,0.5,0.5,0.5h14.6c0.3,0,0.5-0.2,0.5-0.5V2.3C15.8,2,15.6,1.8,15.3,1.8\n\t\tz M14.8,13.2H1.2V2.8h13.6V13.2z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol